export default {
  confirm: '确定',
  cancel: '取消',
  loading: '加载中',
  loadingCompleted: '没有更多的数据了~',
  loadingError: '数据加载异常',
  more: '更多',
  close: '关闭',
  search: '搜索',
  friend: '好友',
  qzone: 'QQ空间',
  wechat: '微信',
  moments: '朋友圈',
  download: '下载',
  shareTo: '分享到'
};
